import React from "react";

// Shared footer for every Section A (public) page.
function SiteFooter() {
  return (
    <footer className="site-footer">
      <span>مجلهٔ دریچه</span>
      <span className="footer-sheet-code">DARICHE / A1 — SHEET 01</span>
      <span>۱۴۰۵ — تمامی حقوق محفوظ است</span>
    </footer>
  );
}

export default SiteFooter;
